import React, { useContext, useEffect, useRef, useState } from "react";
import dummyImg from "../images/dummy_person.png";
import noProperty from "../images/no-property-found.png";
import { Link, useNavigate } from "react-router";
import { API_Path, imgBaseUrl } from "../Const";
import { GetApi } from "../api/api-service";
import { getLastPathParam } from "../components/CommonFun";
import ContectModal from "../components/modal/ContectModal";
import EmailAgentModal from "../components/modal/EmailAgentModal";
import PropertySection from "../components/property/PropertySection";
import CommonPagination from "../components/CommonPagination";
import { BsFacebook } from "react-icons/bs";
import { BsInstagram } from "react-icons/bs";
import { BsTwitterX } from "react-icons/bs";
import qualityListings from "../images/agent/QualityListings.svg";
import badgeResponsive from "../images/agent/BadgeResponsive.svg";
import TruAgentModal from "../components/modal/TruAgentModal";
import QualityLister from "../components/modal/QualityLister";
import ResponsiveBrokerModal from "../components/modal/ResponsiveBrokerModal";
import { IoInformationCircleOutline } from "react-icons/io5";
import ADSOne from "../images/Ads/gfs_1.jpg";
import useTooltipPosition from "../components/CustomizedHook/updatePosition";
import PropertiesLoader from "../components/loader/PropertiesLoader";
import developerLogo from "../images/developer.svg";
import SpinnerLoader from "../components/loader/SpinnerLoader";
import { REBRN, REExperience, RELauguages, RELicense, REMail, RENationality, REProperties, REServiceAreas, RESpecialization, RETelephone, REWhatsapp } from "../components/icons/IconSvg";
import PageTitle from "../components/PageTitle";
import { AuthContext } from "../context/AuthContext";

var aID = "";
function AgentDetails() {
    const navigate = useNavigate();
    const serviceAreasRef = useRef();
    const descriptionRef = useRef();
    const { wrapperRef, tooltipRef, position, updatePosition } = useTooltipPosition();
    const [isLoader, setIsLoader] = useState(true);
    const { specialities, fatchSpecialities } = useContext(AuthContext);
    const [agentData, setAgentData] = useState({});
    const [phoneModalShow, setPhoneModalShow] = useState({ show: false, data: {} });
    const [emailModalShow, setEmailModalShow] = useState(false);
    const [showMore, setShowMore] = useState(false);
    const [pptData, setPPTData] = useState([]);
    const [pLoader, setPLoader] = useState(true);

    const [pageTotal, setPageTotal] = useState({ currentPage: 1, pageSize: 6, totalPages: 1 });
    const [qualityShow, setQualityShow] = useState(false);
    const [truAgentShow, setTruAgentShow] = useState(false);
    const [resAgentShow, setResAgentShow] = useState(false);
    const [isExpanded, setIsExpanded] = useState({ serviceAreas: false, description: false });
    const [maxHeight, setMaxHeight] = useState({ serviceAreas: "76px", description: "76px" });
    const [shouldShowButton, setShouldShowButton] = useState({ serviceAreas: false, description: false });

    useEffect(() => {
        var urlValue = getLastPathParam();
        if (urlValue !== null && urlValue !== undefined && urlValue !== "") {
            let data = urlValue.split("_", 2)[1] ?? urlValue;
            aID = data;
            fetchAgentData(data);
            fetchPropertiesbyAgent(data, pageTotal?.currentPage);
            fatchSpecialities();
        } else navigate("/");
    }, []);

    const toggleExpanded = (key) => {
        const ref = key === "serviceAreas" ? serviceAreasRef : descriptionRef;
        setIsExpanded((prev) => {
            const newState = !prev[key];
            setMaxHeight((prevMax) => ({
                ...prevMax,
                [key]: newState ? `${ref.current.scrollHeight}px` : "76px",
            }));
            return { ...prev, [key]: newState };
        });
    };
    useEffect(() => {
        const checkOverflow = () => {
            if (agentData?.serviceAreas && serviceAreasRef.current) {
                setShouldShowButton((prev) => ({
                    ...prev,
                    serviceAreas: serviceAreasRef.current.scrollHeight >= 80,
                }));
                setMaxHeight((prevMax) => ({
                    ...prevMax,
                    serviceAreas: serviceAreasRef.current.scrollHeight <= 80 ? `${serviceAreasRef.current.scrollHeight}px` : "76px",
                }));
            }
            if ((agentData?.description || agentData?.about) && descriptionRef.current) {
                setShouldShowButton((prev) => ({
                    ...prev,
                    description: descriptionRef.current.scrollHeight >= 80,
                }));
                setMaxHeight((prevMax) => ({
                    ...prevMax,
                    description: descriptionRef.current.scrollHeight <= 80 ? `${descriptionRef.current.scrollHeight}px` : "76px",
                }));
            }
        };
        checkOverflow();
    }, [agentData?.serviceAreas, agentData?.description, agentData?.about]);

    const fetchAgentData = async (id) => {
        try {
            setIsLoader(true);
            let res = await GetApi(API_Path.agentDetails + `/${id}`);
            if (res && res.data.success) setAgentData(res.data.data);
            setIsLoader(false);
        } catch (error) {
            setIsLoader(false);
        }
    };

    const fetchPropertiesbyAgent = async (id, page) => {
        try {
            setPLoader(true);
            let res = await GetApi(API_Path.propertiesbyAgent + `${id}?pageNumber=${page}&pageSize=${pageTotal?.pageSize}`);
            if (res && res.data.success) {
                setPPTData(res.data.data);
                setPageTotal({ currentPage: res.data.currentPage, pageSize: res.data.pageSize, totalPages: res.data.totalPages });
            }
            setPLoader(false);
        } catch (error) {
            setPLoader(false);
        }
    };

    const handleModalHide = () => setEmailModalShow(false);
    const handlePhoneModalHide = () => setPhoneModalShow({ data: {}, show: false });
    const tableCallBack = (page) => fetchPropertiesbyAgent(aID, page);
    const handleTruAgentShow = () => setTruAgentShow(true);
    const handleTruAgentClose = () => setTruAgentShow(false);
    const handleQualityShow = () => setQualityShow(true);
    const handleQualityClose = () => setQualityShow(false);
    const handleResAgentShow = () => setResAgentShow(true);
    const handleResAgentClose = () => setResAgentShow(false);
    const loaders = Array.from({ length: 8 });

    return (
        <>
            <PageTitle title={`${agentData?.name} from ${agentData?.agency?.name}`} />
            <div className="agent-details-sec">
                <div className="container">
                    <div className="agent-profile-details">
                        <div className="agent-profileinfo-inner">
                            <div className="agent-info-inner">
                                <div className="agent-width-left">
                                    <div className="agent-profile">
                                        <img
                                            src={agentData?.path ? imgBaseUrl + agentData?.path : dummyImg}
                                            alt={agentData?.name}
                                            onError={({ currentTarget }) => {
                                                currentTarget.onerror = null;
                                                currentTarget.src = `${dummyImg}`;
                                            }}
                                            loading="lazy"
                                        />
                                    </div>
                                </div>
                                <div className="agent-width-rigth">
                                    <div className="agent-info">
                                        <h1>
                                            {agentData?.name}
                                            {/* <PiSealCheck color="green" className="ms-1" /> */}
                                        </h1>
                                        {agentData?.agency && agentData?.agency?.name && (
                                            <h5 className="agency_link">
                                                <Link to={`/agencies/${agentData?.agency?.slug}_${agentData?.agency?.uId}`}>
                                                    {agentData?.agency?.name} <span>❯</span>
                                                </Link>
                                            </h5>
                                        )}
                                        <div className="top_agent">
                                            {agentData?.isTopAgent && (
                                                <div>
                                                    <button className="tru_btn" onClick={(e) => handleTruAgentShow(e)}>
                                                        {/* <RiMedal2Fill color="#28b16d" /> */}
                                                        Tru<b>Agent</b>
                                                        <span>™</span>
                                                    </button>
                                                </div>
                                            )}
                                            {agentData?.isQualityLister && (
                                                <div>
                                                    <button className="tru_btn lister_btn" onClick={(e) => handleQualityShow(e)}>
                                                        <div>
                                                            <img src={qualityListings} alt="Quality Lister" />
                                                        </div>
                                                        <b>Quality Lister</b>
                                                    </button>
                                                </div>
                                            )}
                                            {agentData?.isHighlyResponsive && (
                                                <div>
                                                    <button className="tru_btn res_btn" onClick={(e) => handleResAgentShow(e)}>
                                                        <div>
                                                            <img src={badgeResponsive} alt="Responsive Broker" />
                                                        </div>
                                                        <b>Responsive Broker</b>
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                        {/* {agentData?.description || (agentData?.about === undefined && agentData?.about === null) && (
                                            <div className="card_derpt">
                                                {showMore ? agentData.description : `${agentData.description.slice(0, 500)}... `}
                                                {agentData.description.length > 500 && (
                                                    <b style={{ color: "#f15a24", cursor: "pointer", paddingLeft: "7px" }} onClick={() => setShowMore(!showMore)}>
                                                        {showMore ? "Read less" : "Read more"}
                                                    </b>
                                                )}
                                            </div>
                                        )}
                                        {agentData?.about && (
                                            <div className="card_derpt">
                                                <bdi ref={descriptionRef} className={`list_label_text w-100${shouldShowButton.description ? " desktop_description" : ""}${!isExpanded?.description ? " desktop_description_trim" : ""}`} style={{ maxHeight: maxHeight.description }}>
                                                    {agentData.about}
                                                </bdi>
                                                {shouldShowButton.description && (
                                                    <button onClick={() => toggleExpanded("description")} className="readmore-btn">
                                                        {isExpanded?.description ? "Read less" : "Read more"}
                                                    </button>
                                                )}
                                            </div>
                                        )} */}
                                        {agentData?.about ? (
                                            <div className="card_derpt">
                                                <bdi ref={descriptionRef} className={`list_label_text w-100${shouldShowButton.description ? " desktop_description" : ""}${!isExpanded?.description ? " desktop_description_trim" : ""}`} style={{ maxHeight: maxHeight.description }}>
                                                    {agentData.about}
                                                </bdi>
                                                {shouldShowButton.description && (
                                                    <button onClick={() => toggleExpanded("description")} className="readmore-btn">
                                                        {isExpanded?.description ? "Read less" : "Read more"}
                                                    </button>
                                                )}
                                            </div>
                                        ) : (
                                            <div className="card_derpt">
                                                <bdi ref={descriptionRef} className={`list_label_text w-100${shouldShowButton.description ? " desktop_description" : ""}${!isExpanded?.description ? " desktop_description_trim" : ""}`} style={{ maxHeight: maxHeight.description }}>
                                                    {agentData?.description}
                                                </bdi>
                                                {shouldShowButton.description && (
                                                    <button onClick={() => toggleExpanded("description")} className="readmore-btn">
                                                        {isExpanded?.description ? "Read less" : "Read more"}
                                                    </button>
                                                )}
                                            </div>
                                        )}
                                        <div className="agent-actions details-btn">
                                            {agentData?.contactMethods?.call && (
                                                <div>
                                                    <button className="button primary_button py-2 px-3" onClick={() => setPhoneModalShow({ show: true, data: agentData })}>
                                                        <RETelephone /> Call
                                                        {/* <IoIosCall /> Call */}
                                                    </button>
                                                </div>
                                            )}
                                            {agentData?.contactMethods?.email && (
                                                <div>
                                                    <button className="button primary_button py-2 px-3" onClick={(e) => setEmailModalShow(true)}>
                                                        <REMail /> Email
                                                        {/* <MdEmail /> Email */}
                                                    </button>
                                                </div>
                                            )}
                                            {agentData?.contactMethods?.whatsApp && (
                                                <div className="wp-btn">
                                                    {/* <div className="agent-actions-btn action-control-btn"> */}
                                                    <button className="button">
                                                        <REWhatsapp /> Whatsapp
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                        {agentData?.socialMediaLinks && agentData?.socialMediaLinks.length > 0 && (
                                            <div className="social_media">
                                                <ul>
                                                    {agentData?.socialMediaLinks.map((item, i) => (
                                                        <li key={i}>
                                                            <a href={item.link} target="_blank" rel="noreferrer" className="">
                                                                {item.socialMediaType.toLowerCase() === "facebook" ? <BsFacebook fill="#3B5998" /> : item.socialMediaType.toLowerCase() === "instagram" ? <BsInstagram fill="#ee2a7b" /> : item.socialMediaType.toLowerCase() === "twitter" ? <BsTwitterX fill="#1DA1F2" /> : ""}
                                                            </a>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="about-agent-sec">
                            <div className="agent_head">
                                <h2>About's {agentData?.name}</h2>
                            </div>
                            {isLoader ? (
                                <SpinnerLoader />
                            ) : (
                                <div className="our-property-fetures">
                                    <ul>
                                        {agentData?.languages && agentData?.agentLanguages.length <= 0 && (
                                            <li>
                                                <div className="about_icon">
                                                    <RELauguages />
                                                </div>
                                                <p>Language(s) :</p>
                                                <span> {agentData?.languages}</span>
                                            </li>
                                        )}
                                        {agentData?.agentLanguages && agentData?.agentLanguages.length > 0 && (
                                            <li>
                                                <div className="about_icon">
                                                    <RELauguages />
                                                </div>
                                                <p>Language(s) :</p>
                                                <span>
                                                    {agentData?.agentLanguages
                                                        .map((item) => item.languageType)
                                                        .join(", ")
                                                        .replace(/, ([^,]*)$/, " & $1")}
                                                </span>
                                                {/* <span>{agentData?.agentLanguages.map((item) => item.languageType)}</span> */}
                                            </li>
                                        )}
                                        {agentData?.expertises && (
                                            <li>
                                                <div className="about_icon">
                                                    <RELauguages />
                                                </div>
                                                <p>Expertise : </p>
                                                <span>{agentData?.expertises}</span>
                                            </li>
                                        )}
                                        {agentData?.serviceAreas && (
                                            <li>
                                                {/* <div
                                                ref={serviceAreasRef}
                                                className={`list_label_text${shouldShowButton.serviceAreas ? " desktop_description" : ""}${
                                                    !isExpanded?.serviceAreas && maxHeight.serviceAreas === "76px" ? " desktop_description_trim" : ""
                                                }`}
                                                style={{ maxHeight: maxHeight.serviceAreas }}
                                            >
                                                <p>Service Areas : </p>
                                                <span>{agentData?.serviceAreas}</span>{" "}
                                            </div>
                                            {shouldShowButton.serviceAreas && (
                                                <button onClick={() => toggleExpanded("serviceAreas")} className="readmore-btn">
                                                    {isExpanded?.serviceAreas ? "Read less" : "Read more"}
                                                </button>
                                            )} */}
                                                {/* <RELocation /> */}
                                                <div className="about_icon">
                                                    <REServiceAreas />
                                                </div>
                                                <p>Service Areas :</p>
                                                <span>
                                                    <bdi ref={serviceAreasRef} className={`list_label_text w-100${shouldShowButton.serviceAreas ? " desktop_description" : ""}${!isExpanded?.serviceAreas && maxHeight.serviceAreas === "76px" ? " desktop_description_trim" : ""}`} style={{ maxHeight: maxHeight.serviceAreas }}>
                                                        {agentData?.serviceAreas}
                                                    </bdi>
                                                    {shouldShowButton.serviceAreas && (
                                                        <button onClick={() => toggleExpanded("serviceAreas")} className="readmore-btn">
                                                            {isExpanded?.serviceAreas ? "Read less" : "Read more"}
                                                        </button>
                                                    )}
                                                </span>
                                            </li>
                                        )}
                                        {agentData?.nationality && (
                                            <li>
                                                {/* <REFlag /> */}
                                                <div className="about_icon">
                                                    <RENationality />
                                                </div>
                                                <p>Nationality : </p>
                                                <span>{agentData?.nationality}</span>
                                            </li>
                                        )}
                                        {agentData?.experienceInYear && (
                                            <li>
                                                {/* <REOfcBag /> */}
                                                <div className="about_icon">
                                                    <REExperience />
                                                </div>
                                                <p>Experience Year : </p>
                                                <span>{agentData?.experienceInYear} Year(s)</span>
                                            </li>
                                        )}
                                        {agentData?.specialization && (
                                            <li>
                                                {/* <REStar /> */}
                                                <div className="about_icon">
                                                    <RESpecialization />
                                                </div>
                                                <p>Specialization : </p>
                                                <span>{agentData?.specialization}</span>
                                            </li>
                                        )}
                                        {agentData?.specialities && agentData?.specialities?.length > 0 && (
                                            <li>
                                                {/* <REStar /> */}
                                                <div className="about_icon">
                                                    <RESpecialization />
                                                </div>
                                                <p>Specialities : </p>
                                                <span>
                                                    {specialities
                                                        ?.filter((item) => agentData?.specialities?.some((s) => s.specialityType === item.type))
                                                        .map((item) => item.name)
                                                        .join(", ")}
                                                </span>
                                            </li>
                                        )}
                                        {agentData?.licenseNumber && (
                                            <li>
                                                {/* <REMIT /> */}
                                                <div className="about_icon">
                                                    <RELicense />
                                                </div>
                                                <p>License Number : </p>
                                                <span>{agentData?.licenseNumber}</span>
                                            </li>
                                        )}
                                        {agentData?.brnNumber && (
                                            <li>
                                                {/* <RESecurity /> */}
                                                <div className="about_icon">
                                                    <REBRN />
                                                </div>
                                                <div className="d-flex agent_info_num">
                                                    BRN
                                                    <div className="wrapper mx-1" ref={wrapperRef} onMouseEnter={updatePosition}>
                                                        <div>
                                                            <IoInformationCircleOutline />
                                                            <div ref={tooltipRef} className={`tooltip ${position}`}>
                                                                Agents working for RERA-registered brokerages in Dubai receive a Broker Registration Number.{" "}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    :
                                                </div>
                                                <span>{agentData?.brnNumber}</span>
                                            </li>
                                        )}
                                        {agentData?.blnNumber && (
                                            <li>
                                                {/* <RESecurity /> */}
                                                <div className="about_icon">
                                                    <REBRN />
                                                </div>
                                                <div className="d-flex agent_info_num">
                                                    BLN
                                                    <div className="wrapper mx-1">
                                                        <IoInformationCircleOutline />
                                                        <div className="tooltip">A Broker Licence Number is issued to agents affiliated with brokerages registered under ADREC in Abu Dhabi.</div>
                                                    </div>
                                                    :
                                                </div>
                                                <span>{agentData?.blnNumber}</span>
                                            </li>
                                        )}
                                        {(agentData?.agentStats?.propertySaleCount || agentData?.agentStats?.propertyRentCount) && (
                                            <li className="rent-span">
                                                {/* <REHome /> */}
                                                <div className="about_icon">
                                                    <REProperties />
                                                </div>
                                                <p>Properties :</p>
                                                <div className="rent_sell">
                                                    {agentData?.agentStats?.propertyRentCount && <span>For Rent ({agentData?.agentStats?.propertyRentCount ? agentData?.agentStats?.propertyRentCount : 0})</span>}
                                                    {agentData?.agentStats?.propertySaleCount && <span>For Sale ({agentData?.agentStats?.propertySaleCount ? agentData?.agentStats?.propertySaleCount : 0})</span>}
                                                </div>
                                            </li>
                                        )}
                                        {agentData?.officeAddress && (
                                            <li>
                                                {/* <RELocation /> */}
                                                <div className="about_icon">
                                                    <RELauguages />
                                                </div>
                                                <p>Address :</p>
                                                <span>{agentData?.officeAddress}</span>
                                            </li>
                                        )}
                                        {agentData?.experience && agentData?.experienceInYear === undefined && agentData?.experienceInYear === null && (
                                            <li>
                                                <div className="about_icon">
                                                    <REExperience />
                                                </div>
                                                <p>Experience :</p>
                                                <span>{agentData?.experience}</span>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className="agent-property">
                <div className="container">
                    <div className="active-agent">
                        <p>Active listings</p>
                    </div>
                    <div className="home-details-inner">
                        <div className="agent-property-inner">
                            {pLoader ? (
                                <div className="agent-property-left">
                                    <div className="row slider-section info-block">
                                        {loaders.map((_, index) => (
                                            <div className="info-block-inner info-block-agent agent_info_width" key={index}>
                                                <PropertiesLoader />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ) : pptData.length > 0 ? (
                                <div className="agent-property-left">
                                    <PropertySection ltsProperties={pptData} name="agent" agentData={agentData} />
                                    <CommonPagination currentPage={pageTotal?.currentPage} pageSize={pageTotal?.pageSize} totalPages={pageTotal?.totalPages} tableCallBack={tableCallBack} />
                                </div>
                            ) : (
                                <div className="agent-property-left text-center">
                                    <img src={noProperty} alt="Currently, there are no active listings" />
                                    <h2 className="agencies_title mt-4">Currently, there are no active listings</h2>
                                </div>
                            )}

                            <div className="agent-property-right">
                                <div className="home-details-right">
                                    {agentData?.agency && (
                                        <div className="broker_container featured-items-sec mb-3">
                                            <div className="luxury-home-sec">
                                                <div className="broker_content">
                                                    <div className="broker_image">
                                                        <img
                                                            src={agentData?.agency?.logoPath ? imgBaseUrl + agentData?.agency?.logoPath : developerLogo}
                                                            alt={agentData?.agency?.name}
                                                            loading="lazy"
                                                            onError={({ currentTarget }) => {
                                                                currentTarget.onerror = null;
                                                                currentTarget.src = `${developerLogo}`;
                                                            }}
                                                        />
                                                    </div>
                                                    <div>
                                                        <h2 className="broker_title">{agentData?.agency?.name}</h2>
                                                        <h5 className="agency_link">
                                                            <Link to={`/agencies/${agentData?.agency?.slug}_${agentData?.agency?.uId}`}>
                                                                About <span>❯</span>
                                                            </Link>
                                                        </h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    <div className="our-connect pt-0">
                                        <div className="our-connect-info h-auto">
                                            <img src={ADSOne} alt="GFS" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {emailModalShow && <EmailAgentModal show={emailModalShow} onHide={handleModalHide} type="agents" />}
            {phoneModalShow.show && <ContectModal show={phoneModalShow.show} onHide={handlePhoneModalHide} data={phoneModalShow.data} />}
            {truAgentShow && <TruAgentModal show={truAgentShow} onHide={handleTruAgentClose} />}
            {qualityShow && <QualityLister show={qualityShow} onHide={handleQualityClose} />}
            {resAgentShow && <ResponsiveBrokerModal show={resAgentShow} onHide={handleResAgentClose} />}

            <div className="">
                <div className="container"></div>
            </div>
        </>
    );
}

export default AgentDetails;
